import { ResponsiveBox } from '@usap/uicomponents'
import styled from 'styled-components'

const HoverBox = styled(ResponsiveBox)`
  width: ${({ boxWidth, boxMargin }) => `calc(${boxWidth} - ${boxMargin * 2}px)`};
  margin: ${({ boxMargin }) => `${boxMargin}px`};
  position: relative;
  
  &:hover {
    box-shadow: 0 3px 16px 0 rgba(0, 0, 0, 0.11);
    background: white;

    .productTitle {
      text-decoration: underline;
    }
  }
`

export default HoverBox
